// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-checkbox[data-v-7b1399fa] label > span {\n  margin-top: 5px !important;\n}\n.fs-lg[data-v-7b1399fa] {\n  font-size: 1.25rem;\n  line-height: 1.5;\n}", ""]);
// Exports
module.exports = exports;
